import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { MenuItem } from '@layouts/toolbar/MenuItem';



export const configMenuDefinition: MenuItem[] = [
	{
		id: NavigateRoutesEnum.importSalesman,
		name: 'Import Salesman',
		requiredRoles: AppRolesEnum.import_Modify,
	},
	{
		id: NavigateRoutesEnum.importTelesales,
		name: 'Import Telesales',
		requiredRoles: AppRolesEnum.import_Modify,
	},
	{
		id: NavigateRoutesEnum.importMerchant,
		name: 'Import Merchant',
		requiredRoles: AppRolesEnum.import_Modify,
	},
	{
		id: NavigateRoutesEnum.importRegionManager,
		name: 'Import Region Manager',
		requiredRoles: AppRolesEnum.import_Modify,
	},
	{
		id: NavigateRoutesEnum.importLocationManager,
		name: 'Import Location Manager',
		requiredRoles: AppRolesEnum.import_Modify,
	},
];